//'use strict';

/** Add any additional Requirements to the Controller here and they will be added to the module Requires array
 */
var additionalRequirementsForModule = [  ];
Array.prototype.push.apply(bookApplication.requires, additionalRequirementsForModule);


bookApplication.service('contentService', 
    ['$http', '$timeout', function ($http, $timeout) {
        var getHtmlContent = function () {
            return $http.get('./domains.json', { cache : true });
        };

        var parseContents = function(contentPromiseResult) {
            try {                
                // checks to see if there is a div Kentico
                var htmlSnippetContent = extractKenticoContentFromString(contentPromiseResult.data, true);

                // ensure that the content is parsed into a JSON object
                var jsonContent = htmlSnippetContent == null
                    ? contentPromiseResult.data
                    : JSON.parse(htmlSnippetContent);
                
                return jsonContent;
            } catch (exception) {
                console.log("Error parsing contents. Check json format.");
                console.log(exception);
            }
        };

        
        /** this method will extract the Html-string element from an string (Kentico Page content)
         * It will return a string if there is a element matching 'div#html-snippet' otherwise returns null
         */
        var extractKenticoContentFromString = function(kenticoPageString, defaultToNull) {
            // create an parse to read the string into a element
            var parser = new DOMParser();
            // extract the content from the Kentico page
            var kenticoPageDocument = parser.parseFromString(kenticoPageString, "text/html");
            
            // setup a default value incase the selector cannot be found
            var defaultValue = defaultToNull ? null : kenticoPageString;
            // checks to see if there is a div Kentico
            var htmlSnippet = kenticoPageDocument.querySelector('div#html-snippet');
            var htmlSnippetContents = htmlSnippet == null
                ? defaultValue
                : htmlSnippet.innerHTML;
            return htmlSnippetContents;
        };

        var getContentPromise = function() {
            var getContentsPromise = getHtmlContent();
            return getContentsPromise.then(function(contentPromiseResult) {
                return parseContents(contentPromiseResult);
            });
        }

        return { 
            getContentPromise: getContentPromise,
            extractKenticoContentFromString : extractKenticoContentFromString
        };
    }
]);